import { ReactNode } from 'react';

interface ApprovalRequestContentWrapperProps {
    children: ReactNode;
}

export const ApprovalRequestContentWrapper = (props: ApprovalRequestContentWrapperProps) => {
    return <div style={{ whiteSpace: 'normal' }}>{props.children}</div>;
};
